/**
 * MediaView
 */

// state
export const viewState = {
    mediaview: {
        isLoading: false,
        thumbnailPending: false,
        currentFileId: null,
        currentItem: {},
        sidebarOpen: true,
    },
};

// mutations
export const viewMutations = {
    setMediaViewIsLoading(state, loading) {
        state.mediaview.isLoading = loading;
    },
    setMediaViewThumbnailPending(state, pending) {
        state.mediaview.thumbnailPending = pending;
    },
    setMediaViewCurrentItem(state, item) {
        state.mediaview.currentItem = item;
    },
    setMediaViewCurrentItemFileId(state, id) {
        state.mediaview.currentFileId = id;
    },
    setMediaViewSidebarOpen(state, open) {
        state.mediaview.sidebarOpen = open;
    },
};

// getters
export const viewGetters = {
    getMediaViewIsLoading(state) {
        return state.mediaview.isLoading;
    },
    getMediaViewThumbnailPending(state) {
        return state.mediaview.thumbnailPending;
    },
    getMediaViewCurrentItem(state) {
        return state.mediaview.currentItem;
    },
    getMediaViewCurrentItemId(state) {
        return state.mediaview.currentItem.id;
    },
    getMediaViewCurrentFileId(state) {
        return state.mediaview.currentFileId;
    },
    getMediaViewSidebarOpen(state) {
        return state.mediaview.sidebarOpen;
    },
};

// actions
export const viewActions = {
    replaceMediaViewItem({ commit, dispatch }, item) {
        return new Promise((resolve) => {
            dispatch('replaceGalleryMediaItem', item).then(() => {
                commit('setMediaViewCurrentItem', item);
                commit('setMediaViewCurrentItemFileId', item.file_id);
                resolve(item);
            });
        });
    },
    /*
     * Replace both gallery and media view media items
     * used in media view so if navigating back to gallery the item is updated
     */
    replaceMediaItem({ dispatch, commit }, media) {
        dispatch('replaceMediaViewItem', media).then((result) => {
            commit('setMediaViewCurrentItemFileId', media.file_id);
            dispatch('replaceGalleryMediaItem', result);
        });
    },
};
